import { render, staticRenderFns } from "./RzzxQy.vue?vue&type=template&id=0ab9e4f6&scoped=true&"
import script from "./RzzxQy.vue?vue&type=script&lang=js&"
export * from "./RzzxQy.vue?vue&type=script&lang=js&"
import style0 from "./RzzxQy.vue?vue&type=style&index=0&id=0ab9e4f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab9e4f6",
  null
  
)

export default component.exports